export const ONBOARDING_STEPS = [
  'language',
] as const;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export type DailySectionKey = 'habits' | 'notes' | 'tasks';
export type HideableSectionKey = DailySectionKey | 'calendar' | 'focus';

export const DEFAULT_DAILY_SECTIONS: DailySectionKey[] = ['habits', 'tasks', 'notes'];
export const DEFAULT_HIDDEN_SECTIONS: HideableSectionKey[] = [];

export interface DailyLayoutSettings {
  sections: DailySectionKey[];
  hiddenSections: HideableSectionKey[];
}

export interface UserSettings {
  dailyLayout?: DailyLayoutSettings;
  monthlyFocus?: Record<string, string>;
  dailyNotes?: Record<string, string>;
}

export interface UserPreferences {
  user_id: string;
  locale: string;
  onboarding_completed_at: string | null;
  settings: UserSettings;
  created_at: string;
  updated_at: string;
}